import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase'; // Assuming your firebase config is exported from here

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState(''); // For success messages
    const [error, setError] = useState('');     // For error messages

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        if (!email) {
            setError('Please enter your email address.');
            return;
        }

        try {
            await sendPasswordResetEmail(auth, email);
            setMessage('Password reset email sent! Check your inbox (and spam folder).');
            setEmail(''); // Clear the input field on success
        } catch (err) {
            console.error('Password Reset Error:', err);
            // Provide user-friendly error messages
            if (err.code === 'auth/user-not-found') {
                setError('No user found with this email address.');
            } else if (err.code === 'auth/invalid-email') {
                setError('Please enter a valid email address.');
            } else {
                setError('Failed to send password reset email. Please try again.');
            }
        }
    };

    return (
        <div className="flex h-screen bg-zinc-900 text-white">
            {/* Left column - Form */}
            <div className="w-full md:w-5/12 overflow-y-auto px-8">
                <div className="py-12">
                    <div className="p-12 w-full   mx-auto">
                        <Link to="/">
                            <img src="/util/app/sp-test-logo-2.png" alt="Logo" className="logo h-16 mb-12 ml-0 md:ml-6" />
                        </Link>

                        <div className="rounded-md bg-white/5 p-8">
                            <h1 className='text-xl font-semibold mb-6 text-gray-200 text-left'>Reset Your Password</h1>

                            {message && <div className="mb-4 p-3 rounded-md bg-green-500/20 text-green-300 text-sm">{message}</div>}
                            {error && <div className="mb-4 p-3 rounded-md bg-red-500/20 text-red-300 text-sm">{error}</div>}

                            {!message && ( // Hide form after success message is shown
                                <form onSubmit={handlePasswordReset}>
                                    <div className='flex flex-col mb-4'>
                                        <label htmlFor="email" className='mb-2 text-sm font-medium text-gray-300'>Email Address</label>
                                        <input
                                            id="email"
                                            type='email'
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="you@example.com"
                                            required
                                            className='block w-full rounded-md border-0 bg-white/5 py-2.5 px-3 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-sky-500 sm:text-sm sm:leading-6 transition duration-150 ease-in-out'
                                        />
                                    </div>

                                    <button
                                        type="submit"
                                        className='w-full py-2.5 mt-4 rounded-md bg-sky-600 text-white font-semibold hover:bg-sky-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-zinc-900 focus:ring-sky-500 transition duration-150 ease-in-out'
                                    >
                                        Send Reset Link
                                    </button>
                                </form>
                            )}

                            <div className="mt-6 text-center text-sm">
                                <Link to="/signin" className="font-medium text-sky-500 hover:text-sky-400">
                                    Back to Sign In
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className='text-left absolute bottom-8 left-8 text-zinc-400 text-sm px-12'>
                        Copyright © {new Date().getFullYear()} Brevit3, Inc. All rights reserved.
                    </div>
                </div>
            </div>

            {/* Right column - Image (hidden on small screens, visible md and up) */}
            <div className="hidden md:block md:w-7/12 bg-cover bg-center" style={{ backgroundImage: "url('/media/logo/sp-login-surfboard-cover-a.jpg')" }}>
                 {/* Optional content overlay */}
            </div>
        </div>
    );
};

export default ForgotPassword; 